module.exports = __webpack_public_path__ + "img/smalllogo.50390a2b.png";